import { Divider, Paper, Stack, Typography } from '@mui/material'
import { FaArrowCircleRight } from 'react-icons/fa';

import './style.css';

export const PaginaCondiciones = ( { timeLeft, stepPosition, setStepPosition }) => {

    const styleText = {
        fontSize: 18,
        lineHeight: 2
    };

  return (
    <Paper>
        <Stack p={3}>
            <Typography fontSize={22}>
                Detección de Necesidades de Capacitación.
            </Typography>
            <Divider />

            <Stack mt={2} className='interlineado-2'>
                <Typography sx={styleText} mb={2}><b>Instructivo:</b> Este instrumento tiene como propósito identificar las necesidades de capacitación del personal y debe ser completado por el supervisor inmediato. Es fundamental que el contenido del formulario sea socializado con cada colaborador bajo su supervisión antes de su envío.</Typography>

                <Typography sx={styleText} mb={2}>Al momento de completar el formulario se deben considerar los siguientes lineamientos:</Typography>

                <ul>
                    <li>Las necesidades de capacitación deben estar alineadas con los objetivos establecidos en el Plan Estratégico Institucional (PEI) y el Plan Operativo Anual (POA) del área correspondiente.</li>
                    <li>El formulario debe ser llenado por el supervisor inmediato en presencia de sus colaboradores, con el fin de asegurar una adecuada socialización y validación de la información.</li>
                    <li>Las capacitaciones propuestas deben estar directamente relacionadas con las funciones actuales del colaborador y orientadas al cumplimiento de los objetivos del área, estas no deben tener más de un año de duración.</li>
                    <li>La consolidación y ejecución de la matriz final de necesidades de capacitación estará a cargo del área de Capacitación, la cual ajustará en función del presupuesto aprobado.</li>
                </ul>

                <Typography sx={styleText} fontWeight='bold' className='interlineado-2'>Contacto</Typography>

                <Typography sx={styleText} className='interlineado-2'>Para cualquier consulta, puede comunicarse con el Departamento de Evaluación del Desempeño y Capacitación.</Typography>

                <div hidden={timeLeft === 0} style={{ fontSize: "3rem", fontFamily: "monospace", textAlign: "center" }}>
                    {timeLeft}
                </div>

                <div  className='mt-4 d-flex justify-content-center'>
                    <button onClick={() => setStepPosition(stepPosition + 1)} hidden={timeLeft > 0} className='btn btn-primary-mem'>
                        Siguiente <FaArrowCircleRight style={{marginBottom: 3}} />
                    </button>
               </div>

            </Stack>
        </Stack>
    </Paper>
  )
}
